import axios from 'axios';
import { API_URL } from './api';

export const invoiceService = {
    list (id) {
        console.log('invoiceService: list');

        return axios
            .get(`${API_URL}/facturen/${id}`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    pdf (id) {
        console.log('invoiceService: pdf', id);

        return axios
            .get(`${API_URL}/facturen/pdf/${id}`, {
                responseType: 'arraybuffer',
            })
            .then((response) => {
                if (response.data)
                {
                    return response.data;
                }

                return response;
            });
    },

    get (id) {
        console.log('invoiceService: get', id);

        return axios
            .get(`${API_URL}/facturen/${id}`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },
};

export default invoiceService;
